<div class="flex gap-3 justify-around items-center h-full">
    @for(button of buttons; track button.text){

    @if((!button.type || button.type === 'icon') && (button.permissions == undefined || button.permissions)){
    <button type="button" [disabled]="button.disabled" (click)="perform_action(button,$event)" [title]="button.text" class="p-2 rounded-lg hover:bg-gray-100 flex justify-center items-center transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed" [ngClass]="{
            'text-primary hover:bg-blue-50': button.color === 'sky',
            'text-red-600 hover:bg-red-50': button.color === 'red',
            'text-gray-600 hover:bg-gray-100': !button.color || (button.color !== 'sky' && button.color !== 'red')
        }">
        <i [class]="button.icon" class="text-xl"></i>
    </button>
    }

    @if(button.type === 'button' && (button.permissions == undefined || button.permissions)){
    <button type="button" [disabled]="button.disabled" (click)="perform_action(button,$event)" class="px-6 py-1.5 rounded-full w-full border border-primary text-primary hover:bg-primary hover:text-white transition-colors duration-200 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed">
        {{button.text}}
    </button>
    }

    @if(button.type === 'icon-filled'){
    <button type="button" [disabled]="button.disabled" (click)="perform_action(button,$event)" [title]="button.text" class="w-9 h-9 min-w-9 min-h-9 max-w-9 max-h-9 rounded-full bg-[#EBF1FF] text-primary flex justify-center items-center hover:bg-[#dbe6fe] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
        <i [class]="button.icon" class="text-xl"></i>
    </button>
    }
    @if(button.type === 'text'){
    <span [class]="button.class">{{button.text}}</span>
    }

    }
</div>